import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import OfferPDFHeader from './OfferPDFHeader';
import OfferPDFItemsTable from './OfferPDFItemsTable';
import OfferPDFTotals from './OfferPDFTotals';
import OfferPDFFooter from './OfferPDFFooter';
import { pdfStyles } from './pdfStyles';

export default function OfferPDFDocument({
  order,
  supplierSections = [],
  lead,
  variant = 'internal',
  supplierName,
  supplierContact,
}) {
  return (
    <Document title={`${order.id}-${variant}`}>
      <Page size="A4" style={pdfStyles.page}>
        <OfferPDFHeader order={order} lead={lead} variant={variant} supplierName={supplierName} supplierContact={supplierContact} />
        {variant !== 'supplier' && order.descriptionToCustomer && (
          <View>
            <Text style={pdfStyles.sectionTitle}>Description to customer</Text>
            <Text>{order.descriptionToCustomer}</Text>
          </View>
        )}
        <OfferPDFItemsTable supplierSections={supplierSections} variant={variant} />
        <OfferPDFTotals supplierSections={supplierSections} variant={variant} />
        {variant !== 'supplier' && order.paymentTerms && (
          <View>
            <Text style={pdfStyles.sectionTitle}>Payment terms</Text>
            <Text>{order.paymentTerms}</Text>
          </View>
        )}
        {variant !== 'supplier' && order.deliveryDate && (
          <View>
            <Text style={pdfStyles.sectionTitle}>Delivery date</Text>
            <Text>{order.deliveryDate}</Text>
          </View>
        )}
        <OfferPDFFooter />
      </Page>
    </Document>
  );
}
